const MEETING_LOCATION =
    Object.freeze(
        {
            INCALL: 0,
            OUTCALL: 1,
            BOTH: 2,
        }
    );

export default MEETING_LOCATION;
